import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ConfluenceSmartCreationModalLoader: LoadableType<{}> = LoadableLazy({
	name: 'ConfluenceSmartCreationModalLoader',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceSmartCreationModalManager" */ '../src/ConfluenceSmartCreationModalManager.tsx'
			)
		).ConfluenceSmartCreationModalManager,
});
